import 'formdata-polyfill';
import axios from 'axios';
import loadHandler from './helpers/loadHandler';
import Observer from 'common/scripts/observer';
import Utils from '../../src/common/scripts/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const dev = process.env.NODE_ENV === 'development';
const url = dev ? '/ajax/searchvisual.php' : '/api/estateSearchVisual/';
const defRotate = '1';
const observer = new Observer();
const defaultPage = 1;

/**
 * Возвращает данные взависимости от текущего состояния поворота.
 * @param {object} state - общий стейт приложения
 * @param {string} element - поле стейта из которого нужно получить данные
 * @returns {object} объект с данными
 */
const getData = (state, element) => {
    const rotate = state.rotate;
    const data = state.data[element];

    return data ? data[rotate] : {};
};

const getCurrentFloorData = (floor, data) => {
    const floorID = Number(floor);
    const result = {};

    data.floors.forEach((item) => {
        const id = Number(item.id);

        if (id === floorID) {
            result.render = item.render;
            result.elements = item.elements;
        }
    });

    return result;
};

const setModifyHeader = (floor = false) => {
    const header = document.querySelector('.j-header');

    header.classList.add('header_theme_fixed');

    return floor ? header.classList.add('header_theme_white-text') : header.classList.remove('header_theme_white-text');
};

export default new Vuex.Store({
    /**
     * Глобальное хранилище для всего приложения
     * Доступ только через геттеры, изменение через мутацию.
     */
    state: {
        data: {
            render        : '',
            elements      : '',
            pointers      : '',
            infrastructure: '',
            floors        : '',
            breadcrumbs   : '',
            views         : [],
            compass       : '',
            panorama      : []
        },
        canvasSize: {
            width : 0,
            height: 0
        },
        filters       : {},
        dataStep      : {},
        floor         : 0,
        form          : '',
        formData      : '',
        rotate        : '1',
        parkings      : [],
        parkingType   : Utils.getUrlParams('parkingType') || '',
        buildingNumber: '',
        numberOfitems : {},
        page          : Utils.getUrlParams('page') || defaultPage,
        sort          : {
            type : Utils.getUrlParams('sort') || 'price',
            order: Utils.getUrlParams('order') || 'asc'
        },
        isProc        : false,
        isReady       : false,
        redirect      : '',
        isPinch       : false,
        oldParkingType: null,
        cleanURL      : false
    },

    /**
     * Методы для получения данных из стейта.
     */
    getters: {
        GET_RENDER(state) {
            return getData(state, 'render');
        },

        GET_PARKINGS(state) {
            const sortType = state.sort.type;
            const sortOrder = state.sort.order;
            let parkingElements = [];

            for (const elem in state.data['elements']) {
                if (state.data['elements'].hasOwnProperty(elem)) {
                    parkingElements.push(state.data['elements'][elem]);
                }
            }

            parkingElements = parkingElements.flat();

            return parkingElements.sort((a, b) => {
                if (sortOrder === 'desc') {
                    return (Number(b[sortType]) || 0) - (Number(a[sortType]) || 0);
                }

                return (Number(a[sortType]) || Infinity) - (Number(b[sortType]) || Infinity);
            });
        },

        GET_BUILDING_NUMBER(state) {
            return state.buildingNumber;
        },

        GET_PARKING_TYPE(state) {
            return state.parkingType;
        },

        GET_OLD_PARKING_TYPE(state) {
            return state.oldParkingType;
        },

        GET_NUMBER_OF_ITEMS(state) {
            return state.numberOfitems;
        },

        GET_PAGE(state) {
            return state.page;
        },

        GET_BUILDING(state) {
            return state.building;
        },

        GET_SORT(state) {
            return state.sort;
        },

        GET_VIEW(state) {
            return state.view;
        },

        GET_SLIDERS(state) {
            return state.sliders;
        },

        GET_ELEMENTS(state) {
            return getData(state, 'elements');
        },

        GET_CANVAS_SIZE(state) {
            return state.canvasSize;
        },

        GET_FILTERS(state) {
            return state.filters;
        },

        GET_POINTERS(state) {
            return getData(state, 'pointers');
        },

        GET_INFRASTRUCTURE(state) {
            return getData(state, 'infrastructure');
        },

        GET_FLOORS(state) {
            return state.data.floors.sort((a, b) => {
                return b.floorNum - a.floorNum;
            });
        },

        GET_BREADCRUMBS(state) {
            return state.data.breadcrumbs;
        },

        GET_BUILDINGS(state) {
            return state.data.filters.buildings;
        },

        GET_SELECTED_BUILDINGS(state) {
            return state.selected;
        },

        GET_SELECTED_OBJECTS(state) {
            return state.selectedObjects;
        },

        GET_VIEWS(state) {
            return state.data.views;
        },

        GET_COMPASS(state) {
            return getData(state, 'compass');
        },

        GET_PANORAMA(state) {
            return getData(state, 'panorama');
        },

        GET_DATA_STEP(state) {
            return state.dataStep;
        },

        GET_FORM_DATA(state) {
            return state.formData;
        },

        GET_FORM(state) {
            return state.form;
        },

        GET_ROTATE(state) {
            return state.rotate;
        },

        GET_IS_PROCESSING(state) {
            return state.isProc;
        },

        GET_IS_READY(state) {
            return state.isReady;
        },

        GET_REDIRECT(state) {
            return state.redirect;
        },

        GET_IS_PINCH(state) {
            return state.isPinch;
        }
    },

    /**
     * События которые введут за собой изменение стейта.
     * https://vuex.vuejs.org/ru/guide/actions.html
     */
    actions: {
        send(context, body) {
            context.commit('SET_IS_PROCESSING', true);
            context.commit('SET_DATA_STEP', body);
            context.commit('SET_FORM_DATA', 'init');

            return new Promise((resolve) => {
                axios.post(url, this.getters.GET_FORM_DATA)
                    .then((response) => {
                        const data = response.data.data;
                        let render = '';
                        let floorData = '';

                        // на шаге выбора квартир, приходит массив всех этажей нужно выбрать текущий.
                        if (body.floor) {
                            floorData = getCurrentFloorData(body.floor, data);

                            if (floorData.render) {
                                // eslint-disable-next-line no-negated-condition
                                render = typeof floorData.render[defRotate].link !== 'undefined' ?
                                    floorData.render[defRotate].link :
                                    '';
                            } else {
                                console.error(`Floor with id ${body.floor} not found`);
                            }
                        } else {
                            // eslint-disable-next-line no-negated-condition
                            render = typeof data.render[defRotate].link !== 'undefined' ?
                                data.render[defRotate].link :
                                '';
                        }

                        context.commit('SET_REDIRECT', data);

                        if (data.redirect && !render) {
                            resolve();

                            return;
                        }

                        loadHandler(render)
                            .then((size) => {
                                context.commit('SET_CANVAS_SIZE', size);
                                context.commit('SET_DEFAULT_ROTATE');
                                context.commit('SET_DATA', data);
                                context.commit('SET_FILTERS', data);

                                if (body.floor) {
                                    context.commit('SET_FLOORS', floorData);
                                }

                                context.commit('SET_IS_PROCESSING', false);
                                context.commit('SET_IS_READY');
                                context.commit('SET_IS_PINCH', true);


                                setModifyHeader(body.floor);
                                resolve();
                            })
                            .catch(() => {
                                throw new Error('При получении рендера произошла ошибка');
                            });
                    })
                    .catch((error) => {
                        throw new Error(`При получении данных произошла ошибка ${error}`);
                    });
            });
        },

        // Паркнинг
        parkingSend(context, body) {
            context.commit('SET_IS_PROCESSING', true);
            context.commit('SET_VIEW');
            context.commit('SET_DATA_STEP', body);
            context.commit('SET_FORM_DATA', 'init');
            context.commit('SET_ONLY_FORM_DATA_PARKING', body);

            return new Promise((resolve) => {
                axios.post(url, this.getters.GET_FORM_DATA)
                    .then((response) => {
                        const data = response.data.data;

                        context.commit('SET_REDIRECT', data);

                        if (data.redirect) {
                            resolve();

                            return;
                        }

                        let render = '';
                        let ParkingData = '';


                        context.commit('SET_IS_READY');
                        context.commit('SET_SLIDERS', data);
                        context.commit('UPDATE_BORDER_SLIDERS', response.data.data);
                        context.commit('SET_FILTERS', data);
                        context.commit('SET_PARKING_TYPE', data);
                        context.commit('SET_BUILDING_NUMBER', data);
                        context.commit('SET_NUMBER_OF_ITEMS', data);
                        context.commit('SET_BUILDING', data.filters);
                        // context.commit('SET_PARKINGS', data);

                        ParkingData = getCurrentFloorData(body.floor, data);

                        // eslint-disable-next-line no-negated-condition, max-len
                        render = typeof ParkingData.render[defRotate].link !== 'undefined' ? ParkingData.render[defRotate].link : '';

                        loadHandler(render)
                            .then((size) => {
                                context.commit('SET_CANVAS_SIZE', size);
                                context.commit('SET_DEFAULT_ROTATE');
                                context.commit('SET_DATA', data);
                                context.commit('SET_FILTERS', data);

                                if (body.floor) {
                                    context.commit('SET_FLOORS', ParkingData);
                                }

                                context.commit('SET_IS_PROCESSING', false);
                                context.commit('SET_IS_READY');
                                context.commit('SET_FORM_DATA_PARKING', body);

                                context.commit('SET_IS_PINCH', true);

                                setModifyHeader(body.floor);
                                resolve();
                            });
                    })
                    .catch((error) => {
                        console.error(`При получении данных произошла ошибка ${error}`);
                        throw new Error();
                    });
            });
        },

        // Событие происходит 1 раз при ините фильтра. Нужно обновить форм-дату.
        initFilterParking(context, body) {
            context.commit('SET_FORM_DATA_PARKING', body);
        },

        // Событие происходит при измении элементов формы.
        changeFilterParking(context, body) {
            const floorId = this.getters.GET_DATA_STEP.floor;

            context.commit('SET_IS_PROCESSING', true);
            context.commit('SET_FORM_DATA_PARKING', body);

            if (body.type === 'reset') {
                context.commit('SET_FORM_DATA', 'reset');
            }

            if (body.newInit) {
                // названия того, что будем удалять при переключении типа недвижимости
                const namesToDel = ['price[min]', 'price[max]', 'area[min]', 'area[max]'];

                // так же относится к нажатым опциям
                for (const pair of context.getters.GET_FORM_DATA.entries()) {
                    if (pair[0].indexOf('option') > -1) {
                        namesToDel.push(pair[0]);
                    }
                }

                namesToDel.forEach((item) => {
                    context.getters.GET_FORM_DATA.delete(item);
                });
            }

            // // Чистим лишние селекты в запросе беку
            // let deleteParams = '';

            // if (context.state.parkingType === 'pantry') {
            //     // названия того, что будем удалять при переключении типа недвижимости
            //     deleteParams = ['price[min]', 'price[max]', 'area[min]', 'area[max]'];
            // } else {
            //     deleteParams = ['pricePantry[min]', 'pricePantry[max]', 'areaPantry[min]', 'areaPantry[max]'];
            // }

            // deleteParams.forEach((item) => {
            //     context.getters.GET_FORM_DATA.delete(item);
            // });


            axios.post(url, context.getters.GET_FORM_DATA)
                .then((response) => {
                    context.commit('SET_IS_READY');

                    // let render = '';
                    const ParkingData = getCurrentFloorData(floorId, response.data.data);

                    // eslint-disable-next-line no-negated-condition, max-len
                    // render = typeof ParkingData.render[defRotate].link !== 'undefined' ? ParkingData.render[defRotate].link : '';

                    context.commit('SET_DATA', response.data.data);
                    context.commit('SET_SLIDERS', response.data.data);
                    context.commit('SET_FILTERS', response.data.data);
                    // context.commit('SET_PARKINGS', response.data.data);
                    context.commit('UPDATE_BORDER_SLIDERS', response.data.data);
                    context.commit('SET_NUMBER_OF_ITEMS', response.data.data);
                    context.commit('SET_PARKING_TYPE', response.data.data);

                    context.commit('SET_FLOORS', ParkingData);
                    context.commit('SET_IS_PROCESSING', false);
                    observer.publish('sliderUpdated');
                    setTimeout(() => {
                        observer.publish('floorRedirect');
                    }, 0);
                })
                .catch((error) => {
                    console.error(`При поиске паркинга произошла ошибка= ${error}`);
                });

            if (!body.cleanURL) {
                context.commit('SET_GET_PARAMS');
            }
        },

        // Событие происходит при сбросе формы
        resetFilter(context, body) {
            context.dispatch('changeFilterParking', body);
        },

        // Событие происходит при обновлении дом элементов фильтра
        updateFilter(context) {
            context.commit('SET_IS_PROCESSING', false);
        },

        // Событие происходит при пагинации по клику на показать еще
        changePage(context) {
            context.commit('SET_PAGE');
        },

        // Событие происходит при смене типа и направления сортировки
        changeSort(context, body) {
            context.commit('SET_SORT', body);
        },

        // Событие происходит при смене типа паркинга
        changeParkingType(context) {
            context.commit('UPDATE_PARKING_TYPE');
            context.commit('SET_OLD_PARKING_TYPE');
        },

        // changeNowParkingType(context) {
        //     context.commit('SET_NOW_PARKING_TYPE');
        // },

        changeFilter(context, form) {
            context.commit('SET_FORM', form);
            context.commit('SET_FORM_DATA', 'filter');
            context.commit('SET_IS_PROCESSING', true);

            axios.post(url, context.getters.GET_FORM_DATA)
                .then((response) => {
                    const data = response.data.data;
                    const floorId = this.getters.GET_DATA_STEP.floor;

                    context.commit('SET_ELEMENTS', data);

                    if (floorId) {
                        context.commit('UPDATE_FLOORS', data);

                        const floorData = getCurrentFloorData(floorId, data);

                        context.commit('SET_FLOORS', floorData);
                    }

                    context.commit('SET_IS_PROCESSING', false);
                })
                .catch((error) => {
                    console.error(`При фильтрации произошла ошибка= ${error}`);
                });
        },


        changeFloor(context, floor) {
            context.commit('SET_IS_PROCESSING', true);

            const floorData = getCurrentFloorData(floor, this.state.data);
            const render = floorData.render[this.getters.GET_ROTATE].link;

            loadHandler(render)
                .then(() => {
                    context.commit('SET_FLOORS', floorData);
                    context.commit('SET_IS_PROCESSING', false);
                });
        },

        changeRotate(context, id) {
            context.commit('SET_ROTATE', id);
        },

        changePosition(context, data) {
            context.commit('SET_POSITION_ELEMENETS', data);
        },

        changeStateLoading(context, state) {
            context.commit('SET_IS_PROCESSING', state);
        },

        changeStatePinch(context, state) {
            context.commit('SET_IS_PINCH', state);
        },

        closeSelected(context, body) {
            context.commit('SET_SELECTED_BUILDINGS_FROM_SELECT', body);
        }
    },

    /**
     * Методы для изменения стейта.
     */
    mutations: {
        SET_CANVAS_SIZE(state, data) {
            state.canvasSize = data;
        },

        SET_VIEW(state) {
            const setup = (mql) => {
                state.view = mql.matches ? 'desktop' : 'mobile';
            };
            const mql = window.matchMedia(`screen and (min-width: ${this._vm.$appOptions.viewBreakpoint}px)`);

            mql.addListener(setup);
            setup(mql);
        },

        SET_GET_PARAMS(state) {
            const query = new URLSearchParams();

            for (const item of state.formData.entries()) {
                query.append(item[0], item[1]);
            }

            query.append('page', state.page);
            query.append('sort', state.sort.type);
            query.append('order', state.sort.order);

            // удаляем тип и гет-параметры раннее полученые из форм-даты
            query.delete('type');
            query.delete('getParams');

            window.history.pushState(null, null, `?${query.toString()}`);
        },

        SET_PAGE(state) {
            state.page = Number(state.page) + defaultPage;
            this.commit('SET_GET_PARAMS');
        },

        SET_SORT(state, body) {
            state.sort.type = body.type;
            state.sort.order = body.order;

            this.commit('SET_GET_PARAMS');
        },

        SET_DATA(state, data) {
            state.data = data;
        },

        SET_ELEMENTS(state, data) {
            state.data.elements = data.elements;
        },

        /**
         * Мутация устанавливает данные от бека для слайдеров.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_SLIDERS(state, data) {
            state.sliders = data.sliders;
        },

        SET_FILTERS(state, data) {
            state.filters = data.filters || {};
        },

        /**
         * Мутация устанавливает данные от бека для select.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные от сервера
         */
        SET_BUILDING(state, data) {
            state.building = data.buildings;
            state.selectedObjects = [];
            state.selected = [];
            // выбранные здания помещаем в другую переменную

            for (const item in data.building) {
                if ({}.hasOwnProperty.call(data.building, item)) {
                    if (data.building[item].checked) {
                        state.selectedObjects.push(data.building[item]);

                        // eslint-disable-next-line no-unused-expressions
                        state.selected.includes(Number(data.building[item].id)) ?
                            state.selected.splice(state.selected.indexOf(Number(data.building[item].id)), 1) :
                            state.selected.push(Number(data.building[item].id));
                    }
                }
            }
            // state.selected = idArr.join(',');
        },

        SET_BUILDING_NUMBER(state, data) {
            state.buildingNumber = data.buildingNumber;
        },

        SET_PARKING_TYPE(state, data) {
            state.parkingType = data.parkingType || {};
        },

        SET_NUMBER_OF_ITEMS(state, data) {
            state.numberOfitems = data.numberOfitems;
        },

        UPDATE_PARKING_TYPE(state) {
            if (state.parkingType === 'parking') {
                state.parkingType = 'pantry';
            } else {
                state.parkingType = 'parking';
            }
        },

        SET_OLD_PARKING_TYPE(state) {
            state.oldParkingType = state.parkingType;
        },

        SET_FLOORS(state, data) {
            Vue.set(state.data, 'render', data.render);
            Vue.set(state.data, 'elements', data.elements);
        },

        UPDATE_FLOORS(state, data) {
            state.data.floors = data.floors;
        },

        SET_ROTATE(state, rotate) {
            this.commit('SET_IS_PROCESSING', true);

            const render = state.data.render[rotate].link;

            loadHandler(render)
                .then(() => {
                    state.rotate = rotate;
                    this.commit('SET_IS_PROCESSING', false);
                });
        },

        SET_DEFAULT_ROTATE(state) {
            state.rotate = defRotate;
        },

        SET_DATA_STEP(state, data) {
            state.dataStep = data;
        },

        SET_FORM(state, form) {
            state.form = form;
        },

        SET_PARKINGS(state, data) {
            state.parkings = [];

            for (const floors in data.floors) {
                if ({}.hasOwnProperty.call(data.floors, floors)) {
                    const eachFloar = data.floors[floors].elements;
                    const eachFloarNumrer = data.floors[floors].floorNum;

                    for (const floor in eachFloar) {
                        if ({}.hasOwnProperty.call(eachFloar, floor)) {
                            eachFloar[floor].forEach((item) => {
                                // добавляем значение этажа для тултипа (да, лень было переделывать)
                                item.tooltip.params[0]['floor'] = eachFloarNumrer;
                                // добавляем значение этажа для сортировки
                                item['floor'] = eachFloarNumrer;
                                // тут еще добавляем, чтобы вообще компот получился и никто не разобрался в этом
                                // это все для сортировки
                                const price = item.tooltip.params[2] ? item.tooltip.params[2]['price'] : 0;

                                item['price'] = item.isSold ? price : 'Продано';

                                state.parkings.push(item);
                            });
                        }
                    }
                }
            }
            // if (Utils.keyExist(data.parking, item)) {
            //     state.parkings.push(data.parking[item]);
            // }

            state.allParkings = data.parkings;
        },

        SET_FORM_DATA(state, type) {
            const form = this.getters.GET_FORM;
            const dataStep = this.getters.GET_DATA_STEP;

            state.formData = form ? new FormData(form) : new FormData();

            for (const item in dataStep) {
                if (Utils.keyExist(dataStep, item)) {
                    state.formData.append(item, dataStep[item]);
                }
            }

            state.formData.append('type', type);

            if (type === 'init') {
                if (window.location.search) {
                    const searchParams = new URLSearchParams(window.location.search);

                    for (const value of searchParams.entries()) {
                        state.formData.append(value[0], value[1]);
                    }
                }

                // Убираем все пробелы из элементов форм-даты (числа с разрядами)
                for (const item of state.formData.entries()) {
                    state.formData.set(item[0], Utils.replaceSpace(item[1]));
                }
            }
        },

        SET_FORM_DATA_PARKING(state, body) {
            if (!body.form && body.step !== 'parking_test') {
                return;
            }

            state.formData = new FormData(body.form);
            state.formData.append('type', body.type || false);
            state.formData.append('step', body.step || false);
            state.formData.append('parkingType', state.parkingType);
            state.formData.append('floor', body.floor);

            // если это первая загрузка (при ней нет формы), и не сброс фильтров
            if (!body.form && body.type !== 'reset') {
                if (window.location.search) {
                    state.formData.append('getParams', window.location.search);
                }
            }

            // Убираем все пробелы из элементов форм-даты (числа с разрядами)
            for (const item of state.formData.entries()) {
                state.formData.set(item[0], Utils.replaceSpace(item[1]));
            }
        },

        SET_ONLY_FORM_DATA_PARKING(state, body) {
            if (!body.form) {
                return;
            }

            const formData = new FormData(body.form);

            for (const val of formData) {
                if (!state.formData.get(val[0])) {
                    state.formData.set(val[0], Utils.replaceSpace(val[1]));
                }
            }
        },

        UPDATE_BORDER_SLIDERS(state, data) {
            // конвертируем объект в массив
            const borders = Object.keys(data.sliders).map((i) => {
                return {[i]: data.sliders[i]};
            });

            // передаем рэндж-слайдеру обновленные границы
            observer.publish('parametricfilterSend', borders, state.parkingType);
        },

        /**
         * Мутация устанавливает данные о выбранных зданиях.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные из фильтра
         */
        SET_SELECTED_BUILDINGS(state, data) {
            // eslint-disable-next-line no-unused-expressions,no-undef
            state.selected.includes(Number(data.building[item].id)) ?
                // eslint-disable-next-line no-undef
                state.selected.splice(state.selected.indexOf(Number(data.building[item].id)), 1) :
                // eslint-disable-next-line no-undef
                state.selected.push(Number(data.building[item].id));
        },

        /**
         * Мутация устанавливает данные о выбранных зданиях.
         * @param {object} state - текущий стейт.
         * @param {object} data - данные из фильтра
         */
        SET_SELECTED_BUILDINGS_FROM_SELECT(state, data) {
            state.selected = data;
        },

        SET_IS_PROCESSING(state, value) {
            state.isProc = value;
        },

        SET_IS_READY(state) {
            state.isReady = true;
        },

        SET_POSITION_ELEMENETS(state, data) {
            const elements = getData(state, data.type);

            if (elements) {
                elements.forEach((item, index) => {
                    item.reposition = data.coords[index];
                });
            }
        },

        SET_REDIRECT(state, data) {
            const redirect = data.redirect || '';

            state.redirect = redirect.match(/^([a-z0-9\-/]+)$/g) ?
                redirect :
                '';
        },

        SET_IS_PINCH(state, value) {
            state.isPinch = value;
        }
    }
});
